import React from 'react';
import carbrid from '../../assets/img/carbrid.jpg';
import closebtn from '../../assets/img/closebtn.png';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import API from "../../Services/BaseService";
import { useEffect } from 'react';
import PageNotFound from '../FallBackUI/PageNotFound';

const Chat = () => {
    const [notificationInfo,setNotificationInfo]=useState([]);
    const sellerDetails = useSelector(state => state.LoginReducer.payload);

    const [errors, setErrors] = useState("");
    const [errorFlag, setErrorFlag] = useState(false);

    useEffect(() => {
        getNotificationDetails();
    },[]);
    const getNotificationDetails=()=>{
        let request={
          seller_dealer_id: sellerDetails.seller_dealer_id,
          seller_id:sellerDetails.seller_id,
          seller_token:sellerDetails.seller_token
        }
        API.post('notificationDetails/condition',request).then(res=>{

            if (res.data.success === true) {
            setNotificationInfo(res.data.data);
            // setNotificationID(res.data.data)
        }
        else {
            setErrors(res.data.error)
            setErrorFlag(true)
        }
               
            }) 
            .catch(function (error) {
              if (error.response) {
                  setErrors(error.response.data.error)
                  setErrorFlag(true)
              }
          });
    }
    
    const getDeleteNotification=(data)=>{
        let request={
        //   notification_id: [data.notification_id],
          seller_dealer_id: sellerDetails.seller_dealer_id,
          seller_id:sellerDetails.seller_id,
          seller_token:sellerDetails.seller_token
        }
        console.log("request Delete", request);

        API.post('delete_notification/update',request).then(res=>{
            // setNotificationCount(res.data.data);
            if (res.data.success === true) {
            getNotificationDetails()
        }
        else {
            setErrors(res.data.error)
            setErrorFlag(true)
        }
               
            }) 
            .catch(function (error) {
              if (error.response) {
                  setErrors(error.response.data.error)
                  setErrorFlag(true)
              }
          });
    }

    return (
<div>
{errorFlag === true ? <PageNotFound error={errors} /> :

    <main id="main" class="inner-page">
    { notificationInfo.length > 0 ? notificationInfo.map ((item) =>
                            
        <div id="notoficationtab" class="notoficationtab">
            <div class="container">
                <div class="notoficationtabblock col-lg-6">
                    <div>
                        <h3>{item.title}</h3>
                    </div>
                   <div class="row content">
                        <div class="notoficationcontent">
                            <div class="notofication-icon col-lg-2  col-md-2">        
                             <img alt="" src={item.image}  />
                            </div>
                            <div class="notoficationbody col-lg-8  col-md-8">
                            <div>{item.time} Hours Ago</div>

                                <p>{item.message}</p>
                                {/* <h5>{item.time} Hours Ago</h5> */}
                            </div>
                            <div class="notofication-close-icon col-lg-2  col-md-2">        
                             <img alt="" src={closebtn} onClick={()=> getDeleteNotification(item)} />
                            </div>
                        </div>
                                                                  
                    </div>
                </div>
            </div>
        </div>):""}
    
    </main>}
    </div>
        
    )
}
export default Chat;